export enum MapFeature {
  DistanceCalculator = 'DistanceCalculator',
  ExportData = 'ExportData',
  Lasso = 'Lasso',
  LocationFinder = 'LocationFinder',
  Search = 'Search',
}
